// setMessageInputHeight.js
'use strict';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Set message input height
 * @kind action
 * @param {number} {height} - message input height.
 * @return {Promise} Action promise.
 */
const setMessageInputHeight =
  ({ height, chatroomId }) =>
  async dispatch => {
    if (!chatroomId) {
      return dispatch({
        type: '',
      });
    }

    const selectPath = ['chat', chatroomId];
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: { selectPath, data: { messageInputHeight: height } },
    });
  };

export default setMessageInputHeight;
